/** @file Named pitch ranges as inclusive band intervals (design 4.3); the narrowest match wins. */
import type { PitchRangeName } from '@zilo/pose3d-format/types/facet';

/** Range name -> [first band, last band], inclusive. */
export const PITCH_RANGES: Readonly<Record<PitchRangeName, readonly [number, number]>> = {
  ALL: [0, 11], NORM: [4, 4], NORM_W: [3, 5],
  UP1: [5, 5], UP2: [6, 6], UP3: [7, 7], UP4: [8, 8], UP5: [9, 9],
  'UP1+': [5, 11], 'UP2+': [6, 11], 'UP3+': [7, 11], 'UP4+': [8, 11], 'UP5+': [9, 11],
  BACK: [10, 10], 'BACK+': [10, 11],
  DOWN1: [3, 3], DOWN2: [2, 2], DOWN3: [1, 1], DOWN4: [0, 0],
  'DOWN1+': [0, 3], 'DOWN2+': [0, 2], 'DOWN3+': [0, 1], DOWN5: [11, 11],
};
